import {useAppContext} from "./useAppContext";
import {useFragment} from "@apollo/client";
import {contentService} from "../api/contentService";

export const useComparisonIdFragment = () => {
    const {productId} = useAppContext();

    const {complete, data} = useFragment({
        fragment: contentService.fragments.product,
        fragmentName: "ProductFragment",
        from: {
            __typename: "Product",
            id: productId
        }
    });

    return {
        complete,
        comparisonId: data?.comparisonId
    }
}